export default __webpack_public_path__ + "static/media/Rectangle 1016.177642d8.png";